<section class="header-btn-wrapper">
  <button type="button" (click)="showItem()" type="button" nz-button nzType="primary" style="margin-right: 5px;">
    <i class="fas fa-fw fa-plus"></i> Add Campaign
  </button>
  <button type="button" (click)="showDaily()"  type="button" nz-button >
    Get Daily Data
  </button>
</section>
<ag-grid-angular
  *ngIf="rendered"
  #agGrid
  domLayout='autoHeight'
  class="ag-theme-alpine"
  [rowData]="data"
  [columnDefs]="columnDefs"
  rowSelection="multiple"
  [defaultColDef]="defaultColDef"
  [pagination]="true"
  [suppressRowClickSelection]="true"
  [enableCellTextSelection]="true"
  (gridReady)="onGridReady($event)"
  [rowHeight]="80"
>
</ag-grid-angular>
